import { ReactNode } from 'react'

export interface InputHintProps {
  hint?: ReactNode
  disabled?: boolean
  hideHint?: boolean
}
